import { css } from '@emotion/react'
import {
  CornerRadius,
  cssVar,
  Shadow,
  ShadowElevation,
  ThemedColors,
  ZIndex,
} from '@opallabs/gem'

export const menu = ({ optionCount }: { optionCount: number }) =>
  css({
    borderRadius: CornerRadius.Large,
    boxSizing: 'border-box',
    display: 'flex',
    flexFlow: 'column nowrap',
    listStyle: 'none',
    marginBlock: 0,
    maxHeight: optionCount && optionCount > 4 ? 218 : 'unset',
    padding: 0,
    position: 'fixed',
    width: 'max-content',
    top: 0,
    left: 0,
    zIndex: ZIndex.Shroud.Popover,
    backgroundColor: cssVar(ThemedColors.Surface1),
    ...Shadow[ShadowElevation.E3],

    // Ensures menu is still interactive when Radix focus trapping is active
    pointerEvents: 'auto',
  })
